import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { ActionIcon, Flex } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
export const TransactionAddButton: React.FC = () => {
  const {
    setOpenModal
  } = useModalAction();
  const handleClick = () => {
    setOpenModal(MODAL.WALLET);
  };
  return <Flex justify={{
    base: 'end',
    sm: 'start'
  }} flex={1} align="center">
      <ActionIcon radius={5} w={{
      base: 40,
      sm: 50
    }} h={{
      base: 40,
      sm: 50
    }} bg="var(--input-variant-color)" onClick={handleClick}>
        <IconPlus size={14} color="var(--mantine-color-prime-0)" />
      </ActionIcon>
    </Flex>;
};